import { createRouter, createWebHistory } from 'vue-router';
import store from '../store';
import ServicesAdmin from '../components/ServicesAdmin.vue'

const routes = [
  {
    path: '/',
    name: 'Login',
    component: () => import('../components/Login.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/users',
    name: 'Users',
    component: () => import('../components/Users.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/proposal/new',
    name: 'NewProposal',
    component: () => import('../components/NewProposal.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('../components/Settings.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/services',
    name: 'ServicesAdmin',
    component: ServicesAdmin,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('../components/Profile.vue'),
    meta: { requiresAuth: true }
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

// Navigation guard
router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters.isAuthenticated;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin);

  if (requiresAuth && !isAuthenticated) {
    console.log('Route requires auth but user is not authenticated');
    next('/');
    return;
  }

  if (requiresAdmin && !store.getters.isAdmin) {
    console.log('Route requires admin but user is not admin');
    next('/proposal/new');
    return;
  }

  if (to.path === '/' && isAuthenticated) {
    console.log('Already authenticated, redirecting to appropriate page');
    next(store.getters.isAdmin ? '/users' : '/proposal/new');
    return;
  }

  next();
});

export default router; 